<template>
  <div class="hello me" v-if="fields.title">
    <prismic-rich-text :field="fields.title" wrapper="div" class="title-main" />

    <div class="me--personal">
      <prismic-image :field="fields.avatar" />

      <prismic-rich-text
        :field="fields.personalData"
        wrapper="div"
        class="personal-data"
      />
    </div>

    <h3>
      <prismic-rich-text :field="fields.subtitle" wrapper="div" />
    </h3>

    <prismic-rich-text :field="fields.content" wrapper="div" />
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      fields: {
        title: null,
        subtitle: null,
        content: null,
        avatar: null,
        personalData: null
      }
    };
  },
  methods: {
    async getContent() {
      const data = await this.$prismic.client.getSingle("home");
      //console.log(data);
      this.fields.title = data.data.title;
      this.fields.subtitle = data.data.subtitle;
      this.fields.content = data.data.content;
      this.fields.avatar = data.data.avatar;
      this.fields.personalData = data.data.personaldata;
      console.log(data);
    }
  },
  created() {
    this.getContent();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
* {
  font-family: "Poppins";
}

h1 {
  text-align: left;
}

h3 {
  margin: 40px 0 0;
  text-align: left;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.title-main {
  border-bottom: 2px solid #2d2d2f;
}

.personal-data {
  width: 600px;
  margin-left: 50px;
}
</style>
